import { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const useFileUpload = (onDrop, maxSize) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const selectedFile = useSelector((state) => state.multimedia.selectedFile);

  const handleDrop = useCallback(
    (acceptedFiles, addFiles = false) => {
      setIsLoading(true);
      setError(null);

      console.log("acceptedFiles 2 => ", acceptedFiles);

      if (onDrop) {
        console.log("acceptedFiles-upload => ", acceptedFiles);

        const validFiles = [];
        const rejectedFiles = [];

        acceptedFiles.forEach((file) => {
          console.log("file => ", file);
          let currentMaxSize = maxSize;
          const typeSizeMap = {
            "image/jpeg": 104857600,
            "image/png": 104857600,
            "image/jpg": 104857600,
            "text/csv": 104857600,
            "application/vnd.openxmlformats-officedocument.presentationml.presentation": 104857600,
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": 104857600,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": 104857600,
            "application/pdf": 104857600,
            "application/zip": 104857600,
            "video/mp4": maxSize,
            "video/3gp": maxSize,
            "application/x-zip-compressed": 104857600,
            "application/x-compressed": 104857600,
            "application/x-7z-compressed": 104857600,
            "application/x-compressed-tar": 104857600,
            "application/x-compressed-tar-gz": 104857600,
            "application/x-compressed-tar-bz2": 104857600,
            "application/x-compressed-tar-xz": 104857600,
          };

          console.log("typeSizeMap => ", file?.type);
          console.log("typeSizeMap[file?.type] => ", typeSizeMap[file?.type]);

          currentMaxSize = typeSizeMap[file?.type] || null;

          console.log("currentMaxSize => ", currentMaxSize);
          if (!currentMaxSize) {
            rejectedFiles.push({
              file,
              reason: "Tipo de archivo no permitido",
            });
            return;
          }

          if (file?.size > currentMaxSize) {
            rejectedFiles.push({
              file,
              reason: `Archivo demasiado grande (máximo ${
                currentMaxSize / 1048576
              } MB)`,
            });
            return;
          }

          if (file?.size === 0) {
            rejectedFiles.push({
              file,
              reason: "Archivo vacío o corrupto",
            });
            return;
          }

          validFiles.push(file);
        });

        // Ordena primero los archivos seleccionados
        const allFiles = [...(selectedFile || []), ...validFiles];
        console.log("allFiles 2 => ", allFiles);

        // Límite de archivos
        if (allFiles?.length > 10) {
          const discardedFiles = allFiles.splice(10);

          discardedFiles.forEach((file) => {
            rejectedFiles.push({
              file,
              reason: "Límite de 10 archivos excedido",
            });
          });

          setError(
            `Solo puedes subir hasta 10 archivos. Algunos archivos fueron descartados: ${discardedFiles
              .map((file) =>
                file?.name?.length > 20
                  ? file.name.substring(0, 20) + "..."
                  : file.name
              )
              .join(", ")}`
          );

          toast.error(
            `Solo puedes subir hasta 10 archivos. Algunos archivos fueron descartados:\n\n- ${discardedFiles
              .map((file) => file?.name)
              .join("\n\n- ")}`
          );
          if (allFiles?.length > 0) {
            setUploadedFiles(allFiles);
            onDrop(allFiles);
          }
          return;
        }

        if (rejectedFiles?.length > 0) {
          const errorMessage = rejectedFiles
            .map((rejected) => `${rejected?.file?.name} (${rejected?.reason})`)
            .join(", ");
          setError(`Algunos archivos no son válidos: ${errorMessage}`);
          toast.error(`Algunos archivos no son válidos:\n\n- ${errorMessage}`);
        }

        if (allFiles?.length > 0) {
          setUploadedFiles(allFiles);
          onDrop(allFiles);
        }
      }

      setIsLoading(false);
    },
    [onDrop, maxSize, selectedFile]
  );

  return {
    isLoading,
    error,
    uploadedFiles,
    handleDrop,
    setError,
  };
};

export default useFileUpload;
